import React, { useContext } from 'react';

export interface DayGridContextProviderProps {
    children: JSX.Element | JSX.Element[];
    enableWorkingHours: boolean;
}

export interface DayGridBehaviorContextSchema {
    enableWorkingHours: boolean;
}

const BehaviorContext = React.createContext<DayGridBehaviorContextSchema | undefined>(undefined);

const DayGridContextProvider = (props: DayGridContextProviderProps) => {
    return (
        <BehaviorContext.Provider
            value={{
                enableWorkingHours: props.enableWorkingHours,
            }}>
            {props.children}
        </BehaviorContext.Provider>
    );
};

export default DayGridContextProvider;

export function useBehaviorContext() {
    const behaviorContext = useContext(BehaviorContext);
    return behaviorContext;
}
